var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { OnChanges, SimpleChanges } from '@angular/core';
var TimeToFirstContactChartComponent = /** @class */ (function () {
    function TimeToFirstContactChartComponent() {
        var _this = this;
        this.intervals = [1, 2, 3, 5, 10, 15, 25, 45, 45];
        this.labels = this.intervals.map(function (interval, index) { return (_this.isLastInterval(index) ? ">" + interval + "min" : "<" + interval + "min"); });
        this.chartData = [
            {
                labels: this.labels,
                data: [],
                label: 'Time to first contact',
                backgroundColor: Array.from({ length: this.labels.length }, function () { return '#50A89D'; })
            }
        ];
    }
    Object.defineProperty(TimeToFirstContactChartComponent.prototype, "dataAvailable", {
        get: function () {
            return this.stats && this.stats.timesToFirstContact && this.stats.timesToFirstContact.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    TimeToFirstContactChartComponent.prototype.ngOnChanges = function (changes) {
        if (this.dataAvailable) {
            this.changeChartData(this.stats.timesToFirstContact, this.stats.leads);
        }
        else {
            this.showNoDataAvailable();
        }
    };
    TimeToFirstContactChartComponent.prototype.showNoDataAvailable = function () {
        // 'random' data
        this.changeChartData([
            { minute: 1, numberOfContacts: 127 },
            { minute: 2, numberOfContacts: 100 },
            { minute: 4, numberOfContacts: 93 },
            { minute: 8, numberOfContacts: 43 },
            { minute: 13, numberOfContacts: 33 },
            { minute: 513, numberOfContacts: 3 }
        ], 430);
    };
    TimeToFirstContactChartComponent.prototype.changeChartData = function (timesToFirstContact, leadsCount) {
        var _this = this;
        var copy = this.chartData.slice();
        var predicate = function (index) { return (_this.isLastInterval(index) ? _this.sumAllContacts : _this.sumContactsBeforeInterval); };
        copy[0].data = this.intervals
            .map(function (interval, index) { return _this.sumContactsPerInterval(timesToFirstContact, interval, predicate(index)); })
            .map(function (sum) { return sum * 100 / leadsCount; });
        this.chartData = copy;
    };
    TimeToFirstContactChartComponent.prototype.sumAllContacts = function () {
        return true;
    };
    TimeToFirstContactChartComponent.prototype.sumContactsBeforeInterval = function (minute, interval) {
        return minute <= interval;
    };
    TimeToFirstContactChartComponent.prototype.isLastInterval = function (index) {
        return index === this.intervals.length - 1;
    };
    TimeToFirstContactChartComponent.prototype.sumContactsPerInterval = function (timesToFirstContact, interval, predicate) {
        return timesToFirstContact
            .filter(function (_a) {
            var minute = _a.minute;
            return predicate(minute, interval);
        })
            .reduce(function (sum, _a) {
            var numberOfContacts = _a.numberOfContacts;
            return sum + numberOfContacts;
        }, 0);
    };
    TimeToFirstContactChartComponent.prototype.chartConfigMapper = function (defaultConfig) {
        var config = __assign({}, defaultConfig);
        config.tooltips.callbacks.title = function () { return ''; };
        config.tooltips.callbacks.label = function (tooltipItem, data) {
            var min = data.datasets[0].labels[tooltipItem.index];
            var percent = Number(data.datasets[0].data[tooltipItem.index]).toFixed(1) + '%';
            var isLast = tooltipItem.index === data.datasets[0].data.length - 1;
            return percent + " of leads were contacted " + (isLast ? 'in more than' : 'in less than') + " " + min.substring(1);
        };
        config.scales.xAxes[0].barPercentage = 1.0;
        config.plugins.datalabels.formatter = function (value) { return Number(value).toFixed(1) + '%'; };
        config.plugins.datalabels.font = { size: 11 };
        return config;
    };
    return TimeToFirstContactChartComponent;
}());
export { TimeToFirstContactChartComponent };
